export default __webpack_public_path__ + "static/media/car.bg.d4e43aef.svg";